import { render, staticRenderFns } from "./branch_list.vue?vue&type=template&id=4b8823c6&scoped=true&"
import script from "./branch_list.vue?vue&type=script&lang=js&"
export * from "./branch_list.vue?vue&type=script&lang=js&"
import style0 from "./branch_list.vue?vue&type=style&index=0&id=4b8823c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8823c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8823c6')) {
      api.createRecord('4b8823c6', component.options)
    } else {
      api.reload('4b8823c6', component.options)
    }
    module.hot.accept("./branch_list.vue?vue&type=template&id=4b8823c6&scoped=true&", function () {
      api.rerender('4b8823c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/organization_management/form/branch_list.vue"
export default component.exports